import axios from 'axios'

import { setEndpointStatusOutside } from '../store/endpointStatus'
import { setLoggedInStatusOutside } from '../store/globalStore'
import { RULE_TYPES } from '../utils/Constants'

export const IS_PROD = process.env.NODE_ENV === 'production'

let prodBackend = 'https://app.marketcalculus.ai:9090'
export let prodFrontend = 'https://app.marketcalculus.ai'
let acao = 'https://app.marketcalculus.ai'
if (window.location.host.startsWith('test.marketcalculus.ai')) {
  prodBackend = 'https://test.marketcalculus.ai:9091'
  prodFrontend = 'https://test.marketcalculus.ai:8080'
  acao = 'https://test.marketcalculus.ai:9091'
}
export const BASE_URL = IS_PROD ? prodBackend : 'http://127.0.0.1:9090'
export const HOMEPAGE_URL = 'https://marketcalculus.ai'

const createAxiosInstance = () => {
  const instance = axios.create({
    baseURL: BASE_URL + '/api/v1',
    withCredentials: true
  })

  instance.interceptors.request.use(config => {
    const lang = localStorage.getItem('lang') || 'en'
    config.headers = {
      ...config.headers,
      'Access-Control-Allow-Origin': acao,
      'Content-type': 'application/json',
      dil: lang
    }
    return config
  })

  instance.interceptors.response.use(
    (response) => {
      return response
    },
    (err) => {
      if (RULE_TYPES.includes(err?.response?.data?.detail?.ruleType)) {
        setEndpointStatusOutside('errorMessage', err.response.data.detail)
        return Promise.reject(err)
      }

      // Handle McRestException
      const nestedDetail = err?.response?.data?.detail?.body?.detail
      if (nestedDetail) {
        setEndpointStatusOutside('errorMessage', nestedDetail)
        return Promise.reject(err)
      }

      const currentPath = window.location.pathname
      const isOnAuthPage = currentPath.includes('/login') ||
                          currentPath.includes('/register') ||
                          currentPath.includes('/error') ||
                          currentPath.includes('/reset') ||
                          currentPath.includes('/new-password')

      const requestUrl = err?.config?.url || ''

      if (err?.response?.status === 401 && requestUrl.includes('/auth/check-token')) {
        setLoggedInStatusOutside(false)
        return Promise.reject(err)
      }

      if (err?.response?.status && err.response.status >= 400 && !isOnAuthPage) {
        setEndpointStatusOutside('errorMessage', {
          ruleType: 'GENERIC_HTTP_ERROR',
          statusCode: err.response.status,
          message: err.response.data?.message || err.response.data?.detail || 'An unexpected error occurred'
        })
        return Promise.reject(err)
      }

      if (!err?.response && !isOnAuthPage) {
        setEndpointStatusOutside('errorMessage', {
          ruleType: 'GENERIC_NETWORK_ERROR',
          message: 'Network error - please check your connection'
        })
      }

      return Promise.reject(err)
    }
  )

  return instance
}

const axiosInstance = createAxiosInstance()
export default axiosInstance
